import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserPresenceHistoryRoutingModule } from './user-presence-history-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UserPresenceHistoryRoutingModule
  ]
})
export class UserPresenceHistoryModule { }
